import Badge from 'components/badge/badge';
import { taskTypeLabel, taskTypeOf } from 'constants/taskTypes';
import useText from 'hooks/useText';

// The type of a task, in the colour of its badge. An appointment ticked on
// the home page reads « Rendez-vous ».
const TaskTypeBadge = ({ row }) => {
  const { language, text } = useText('tasks');
  const label = row.kind === 'appointment' ? text('appointment') : taskTypeLabel(language, row.type);
  return <Badge type={taskTypeOf(row.type).badge}>{label}</Badge>;
};

export default TaskTypeBadge;
